import React from "react";
import { Link } from "react-router-dom";

const Footer = ({ setShowCerezlerPopup }) => {
  const handleCerezAyarlariClick = () => {
    setShowCerezlerPopup(true);
  };

  return (
    <footer className="bg-dark pt-8 py-16 h-auto relative rounded-2xl ">
      <div className="container flex flex-wrap gap-8 md:gap-12 lg:gap-0 justify-between items-start ">
        <div className="col1 flex flex-col gap-6 w-full lg:w-auto">
          <Link className="footerLogo">
            <img src="/logoGreen.svg" alt="logo" className="w-auto h-auto" />
          </Link>
          <div className="flex items-center gap-4">
            <p className="text-base p-dark-style">Bizi Takip Edin </p>
            <span>
              {" "}
              <img src="/arrow-forward.svg" />
            </span>
            <Link
              to="https://www.linkedin.com/company/juniorscenter/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/Linkedin.svg" alt="LinkedIn" className="w-6 h-6" />
            </Link>
            <Link
              to="https://www.instagram.com/centerjuniors?igsh=a2Vsa3J3ZGdmZHRx"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="/instagram.svg" alt="Instagram" className="w-6 h-6" />
            </Link>
          </div>
          <Link
            className="text-base p-dark-style mt-6 block"
            to="mailto:info@juniorscenter.com"
          >
            info@juniorscenter.com
          </Link>
        </div>
        <div className="hidden lg:block">
          <img src="/cizgi.svg" alt="Vertical Divider" />
        </div>
        <div className="col2 flex flex-col gap-4 w-full md:w-1/2 lg:w-auto">
          <p className="text-base p-dark-style">Menü</p>
          <ul className="text-base font-sm text-footerGray leading-[24px] tracking-wide flex flex-col gap-2">
            <li>
              <Link to="/">Anasayfa</Link>
            </li>
            <li>
              <Link to="/projeler">Projeler</Link>
            </li>
            <li>
              <Link to="/juniorlar">Juniorlar</Link>
            </li>
            <li>
              <Link to="/seniorlar">Seniorlar</Link>
            </li>
            <li>
              <Link to="/sikca-sorulan-sorular">SSS</Link>
            </li>
          </ul>
        </div>
        <div className="hidden lg:block">
          <img src="/cizgi.svg" />
        </div>
        <div className="col3 flex flex-col gap-4 w-full md:w-1/2 lg:w-auto">
          <p className="text-base p-dark-style">Sözleşmeler</p>
          <ul className="text-base font-sm text-footerGray leading-[24px] tracking-wide flex flex-col gap-2">
            <li>
              <Link to="/acik_riza_metni?fromFooter=true">
                Açık Rıza Metni
              </Link>
            </li>
            <li>
              <Link to="/uyelik_kullanici_sozlesmesi?fromFooter=true">
              Üyelik ve Kullanıcı Sözleşmesi
              </Link>
            </li>
            <li>
              <Link to="/kvkk?fromFooter=true">
              KVKK 
              </Link>
            </li>
            <li>
              <Link to="/gizlilik_cerez_politikasi?fromFooter=true">
              Gizlilik ve Çerez Politikası
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="bg-darkerFont mt-8 absolute bottom-0 right-0 left-0">
        <p className="xl:max-w-[1500px] md:max-w-[1280px] sm:max-w-[640px]  mx-auto p-5 text-base font-sm text-footerGray leading-[24px] tracking-wide text-center py-4 flex justify-start">
          Copyright © 2025 | All Rights Reserved
        </p>
      </div>
    </footer>
  );
};

export default Footer;
